import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        // console.log('HttpRequest: ' + request.url);
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        request = request.clone({
            withCredentials: true, // allow cookie authentication
            responseType: 'json',
            setHeaders: {
                'Content-Type': 'application/json'                
            }
        });

        // if (currentUser && currentUser.JwtToken) {
        //     request = request.clone({
        //         withCredentials: true, // allow cookie authentication
        //         setHeaders: {
        //             Authorization: `Bearer ${currentUser.JwtToken}`,
        //             'Content-Type': 'application/json'
        //         }
        //     });
        // }
        // else{
        //     request = request.clone({
        //         withCredentials: true, // allow cookie authentication
        //         setHeaders: {
        //             'Content-Type': 'application/json'
        //         }
        //     });
        // }
        return next.handle(request); // call the next interceptor in the chain
    }
}